package org.vreo.devicehub.features.core.presentation.components

import androidx.compose.runtime.Composable
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.ui.Modifier
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.window.DialogProperties

/**
 * Display a loading dialog.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Preview
@Composable
fun LoadingDialog(
    modifier: Modifier = Modifier
) {
    BasicAlertDialog(
        onDismissRequest = { },
        modifier = modifier,
        properties = DialogProperties(),
    ) {
        CircularProgressIndicator()
    }
}
